import { refillTypesList } from './constants';
import { getProvider } from '../../../../../helpers/getters';
import { getProviderFormService } from '../../helper';

export const getRefillTypeList = (form, providerForm, config) => {
  if (form && config) {
    let refillList = Object.values(refillTypesList);
    const { refill_paid_options } = config;

    const { mode, provider_id, provider_service_id } = form;
    if (mode === 1) {
      const provider = getProvider(provider_id);
      if (provider) {
        const providerFormService = getProviderFormService(provider_service_id, providerForm);
        const providerServiceUseRefill = !!(providerFormService && providerFormService.service_refill);

        refillList = refillList.filter((type) => {
          switch (type.value) {
          // Provider
          case 1:
            if (providerServiceUseRefill) {
              return true;
            }
            return false;
          // Paid provider (Refiller)
          case 2:
            if (!refill_paid_options) {
              return false;
            }
            return true;
          default:
            return true;
          }
        })
      }
      return refillList
        .map((type) => type);
    }

    if (mode === 0) {
      return refillList
        .map((type) => type)
        .filter((type) => type.value === 3)
    }
  }
  return new Error(`not found form or config, form - ${typeof form}, config - ${typeof config}`)
};
